import React, {useRef} from "react";
import "./style.css";
import { Link } from "react-router-dom"; 
import image from "../../assets/Mask Group 2.png";

function SearchSection() {

  const input = useRef(null);

  return (
    <div className="  bg-primary lg:px-20 md:px-10 px-2 ">
      <div className="herosection min-h-[92vh] flex flex-col items-center justify-center">
        <div className="lg:px-64 md:px-32">
          <p className="text-center  font-bold text-white lg:text-5xl md:text-3xl text-2xl leading-snug	">
            Find and buy the best advertising options online
          </p>
          <p className="text-center md:text-sm  text-white pt-5 mt-2 mb-10 font-light ">
            Qui soluta quis libero laudantium facilis. Eum mollitia culpa. Aut
            inventore rerum itaque quisquam repellat. Reiciendis fuga totam quo
            ut. Quibusdam ut eligendi eius est nulla consequatur porro sed enim.
          </p>
          <div className="search">
            <div className="flex items-center">
              <input
                ref={input}
                type="text"
                className="rounded-full w-full p-4"
                placeholder="Search channel, media etc."
              />
              <button className="bg-primary text-white -ml-32 rounded-full py-2 px-8">
                Search
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SearchSection;
